import { api, TokenProvider } from '@src/main/modules/common/common/infrastructure/http/axios';
import {
  LoginStatistics,
  LoginStatisticsCreate,
  ReportStatistics,
  ReportStatisticsCreate,
} from '@src/main/modules/common/statistics/domain/Statistics';
import { StatisticsRepository } from '@src/main/modules/common/statistics/domain/StatisticsRepository';
import { LoginStatisticsResponse } from '@src/main/modules/common/statistics/infrastructure/StatisticsResponse';

export const createStatisticsHttpRepository = (
  tokenProvider: TokenProvider,
): StatisticsRepository => new StatisticsHttpRepository(tokenProvider);

class StatisticsHttpRepository implements StatisticsRepository {
  private readonly tokenProvider: TokenProvider;

  constructor(tokenProvider: TokenProvider) {
    this.tokenProvider = tokenProvider;
  }

  async findAllLoginStatistics(): Promise<LoginStatistics[]> {
    const token = await this.tokenProvider.getToken();
    const response = await api.get<LoginStatisticsResponse[]>('/statistics-login', token);
    return response;
  }

  async saveLoginStatistics(loginStatistics: LoginStatisticsCreate): Promise<void> {
    const token = await this.tokenProvider.getToken();
    await api.post('/statistics-login', token, loginStatistics);
  }

  async findAllReportsStatistics(): Promise<ReportStatistics[]> {
    const token = await this.tokenProvider.getToken();
    const response = await api.get<ReportStatistics[]>('/statistics-report', token);
    return response;
  }

  async saveReportStatistics(reportStatistics: ReportStatisticsCreate): Promise<void> {
    const token = await this.tokenProvider.getToken();
    await api.post('/statistics-report', token, reportStatistics);
  }
}
